import { Location } from 'history';
import { createElement, ReactElement } from 'react';
import * as Router from 'universal-router';
import Dependency from '../core/dependency';
import State from '../core/state';

// Routes
import ContentSelectRoute from '../view/routes/ContentSelectRoute';
import ContentSelectMobileRoute from '../view/routes/MobileRoute/ContentSelectRoute';
import CartRoute from '../view/routes/CartRoute';
import PaymentRoute from '../view/routes/PaymentRoute';
import PaymentOnlyDeliveryRoute from '../view/routes/PaymentOnlyDeliveryRoute';
import PaymentOnlyTakeoutRoute from '../view/routes/PaymentOnlyTakeoutRoute';
import ConfirmRoute from '../view/routes/ConfirmRoute';
import SigninRoute from '../view/routes/SigninRoute';
import InviteRoute from '../view/routes/InviteRoute';
import SignupRoute from '../view/routes/SignupRoute';
import UserForHeaderRoute from '../view/routes/Headers/UserRoute';
import MypageRoute from '../view/routes/MypageRoute';
import ShipMethodChangePartsRoute from '../view/routes/Parts/Button/TakeoutChangeRoute';
import ProductCardPartsRoute from '../view/routes/Parts/Card/ProductRoute';
import NotFoundRoute from '../view/routes/NotFoundRoute';

type Context = {
  path: string;
  props: {
    location: Location;
    dependency: Dependency;
    state: State;
    attrs: any;
  };
};

const routes: Router.Route<ReactElement<any>, Context> = {
  path: '/',
  action: async ({ next }) => {
    return await next();
  },
  children: [
    {
      path: '/mobile',
      action: async ({ next }) => await next(),
      children: [
        {
          path: '/form',
          action: async ({ props }) => {
            return createElement(ContentSelectMobileRoute, { ...props });
          },
        },
      ],
    },
    {
      path: '/form',
      action: async ({ props }) => {
        return <ContentSelectRoute {...props} />;
      },
    },
    {
      path: '/cart',
      action: async ({ props }) => {
        return createElement(CartRoute, { ...props });
      },
    },
    {
      path: '/payment',
      action: async ({ next }) => await next(),
      children: [
        {
          path: '/',
          action: async ({ props }) => {
            return createElement(PaymentRoute, { ...props });
          },
        },
        {
          path: '/delivery',
          action: async ({ props }) => {
            return createElement(PaymentOnlyDeliveryRoute, { ...props });
          },
        },
        {
          path: '/takeout',
          action: async ({ props }) => {
            return createElement(PaymentOnlyTakeoutRoute, { ...props });
          },
        },
      ],
    },
    {
      path: '/confirm',
      action: async ({ props }) => {
        return createElement(ConfirmRoute, { ...props });
      },
    },
    {
      path: '/login',
      action: async ({ props }) => {
        return createElement(SigninRoute, { ...props });
      },
    },
    {
      path: '/invite',
      action: async ({ props }) => {
        return createElement(InviteRoute, { ...props });
      },
    },
    {
      path: '/signup',
      action: async ({ props }) => {
        return createElement(SignupRoute, { ...props });
      },
    },
    {
      path: '/header',
      action: async ({ next }) => await next(),
      children: [
        {
          path: '/user',
          action: async ({ props }) => {
            return createElement(UserForHeaderRoute, { ...props });
          },
        },
      ],
    },
    {
      path: '/user',
      action: async ({ next }) => await next(),
      children: [
        {
          path: '/edit',
          action: async ({ props }) => {
            return createElement(MypageRoute, { ...props });
          },
        },
      ],
    },
    {
      path: '/parts',
      action: async ({ next }) => await next(),
      children: [
        {
          path: '/buttons',
          action: async ({ next }) => await next(),
          children: [
            {
              path: '/ship-method',
              action: async ({ props }) => {
                return createElement(ShipMethodChangePartsRoute, { ...props });
              },
            },
          ],
        },
        {
          path: '/card',
          action: async ({ next }) => await next(),
          children: [
            {
              path: '/product',
              action: async ({ props }) => {
                return createElement(ProductCardPartsRoute, { ...props });
              },
            },
          ],
        },
      ],
    },
    {
      path: '*', // wildcard route (must go last)
      action: ({ props }) => createElement(NotFoundRoute, { ...props }, null),
    },
  ],
};

export default routes;
